<script>
import { defineComponent, computed, inject } from 'vue'
import { useRoute } from 'vue-router'
import List from '@project/components/List.vue'
import { getNiceString } from '@kit/utils/Time'

export default defineComponent({
  name: "Job",
  setup() {
    const route = useRoute()
    const id = computed(() => route.params.id )
    const hydrate = inject("hydrate")

    const { prefetch } = hydrate({
      // prefetch:[{
      //   name:"job",
      //   params() {
      //     return route.params.id
      //   }
      // }],
      prefetch:[
        { 
          name:"job", 
          params() { return id.value },
          cache(id) { return id }
        }
      ],
      metadata(meta, { job }) {
        meta.addCanonical()
        meta.addTitle(`WeCare | Jobs | ${job.display_title}`)
        meta.addMetaItem([
          { name:'description', content: job.description },
          { name:'og:title', content: `WeCare | Jobs | ${job.display_title}` },
          { name:'og:description', content: job.description },
        ])
      }
    })

    const job = computed(() => {
      return prefetch.value ? prefetch.value.job : null
    })

    return { job, getNiceString, id }
  },
  components: {
    List
  }
});
</script>

<style scoped>

.logo-img {
  width:90px;
  left:-80px; 
  top:0px;
}
.logo-img > img {
  object-position: top;
}
.white-heart {
  left:auto;
  width:30px;
  right:10px; 
  top:10px;
}

.hours-of-operation {
  padding:18px;
  color:white;
  border-radius: 10px;
  background: rgb(12,119,151);
  background: linear-gradient(55deg, rgba(12,119,151,1) 0%, rgba(22,62,111,1) 100%);
}
.hours-of-operation .day {
  font-size:1.1em;
}
.hours-of-operation .hours {
  white-space:nowrap;
  font-size:1.1em;
}

.img {
  width:300px;
}

.waves > img {
  object-fit:contain; 
  width:100%; 
  height:auto;
}


/*less than md*/
@media (max-width : 960px) {

  .waves > img {
    object-fit:cover; 
    width:100%; 
    height:60px;
    object-position:0px;
  }

  .invisible-ltm {
    display:none;
  }

  .width-ltm-100 {
    width: 100%;
  }
  .logo-img {
    width:40px;
    left:-10px; 
    top:0px;
  }
  .hours-of-operation.width {
    width: 100%;
  }
}

</style>

<style>
.PaginationControl {
  /* padding:10px; */
}

.Page:hover {
  border: 0px !important;
}

button.Page.Page-active {
  background:#163E6F !important;
  padding:15px !important;
  color:white;
  border-radius:5px !important;
  border: 0px !important;
}
button.Page {
  background:#457cbf !important;
  padding:15px !important;
  color:white;
  border-radius:5px !important;
}
</style>

<template>
  <main v-if="job" class="sb sb-v sb-greedy sb-g20 padding-lr" role="main" style="z-index:99;">
    <h2 class="sb sb-text">{{job.display_title}}</h2>
    <div class="sb sb-text" v-html="job.description"></div>
    <div v-if="job.close_date && job.close_date != '0000-00-00'" class="sb sb-text">Applications close: {{getNiceString(job.close_date)}}</div>
    <div class="sb sb-h sb-ltm-h2v sb-uniform-2">
      
      <List v-if="job.qualifications && job.qualifications.items && job.qualifications.items.length > 0" class="sb" :list="job.qualifications"></List>

      <div v-if="job.location" class="sb sb-v hours-of-operation width-ltm-100">
        <h3 class="sb sb-text">Location</h3>
        <div class="sb-abox white-heart">
          <img src="@images/STHS-WeCare-logo_white-heart.png" style="object-fit:contain; width:100%; height:auto;"/>
        </div>
        <ul class="sb sb-v sb-gr sb-g10" style="margin-top:10px; padding:0px;">
          <li class="sb sb-text">{{job.location.title}}</li>
          <li class="sb sb-text">{{job.location.address.line_1}}</li>
          <li v-if="job.location.address.line_2" class="sb sb-text">{{job.location.address.line_2}}</li>
          <li class="sb sb-text">{{job.location.address.city}}, {{job.location.address.state}} {{job.location.address.zip}}</li>
          <router-link class="sb sb-text teal" style="font-weight:bold;" :to="`/locations/${job.location.page_name}`">See location details</router-link>
        </ul>
      </div>
      <div v-else class="sb width-ltm-100"></div>

    </div>
    <div v-if="job.contact && job.contact.phone_number" class="sb sb-text">
      For more info, contact: <router-link :to="`/contact/${job.contact.id}`">{{job.contact.name}}</router-link> | {{job.contact.phone_number}} | {{job.contact.email}}
    </div>
    <div v-if="job.contact && !job.contact.phone_number" class="sb sb-text">
      For more info, contact: <router-link :to="`/contact/${job.contact.id}`">{{job.contact.name}}</router-link> | {{job.contact.email}}
    </div>
  </main>
  <main v-else class="sb sb-v sb-g20 padding-lr" role="main" style="z-index:99;">
    <div class="sb loading-shine sb-explicit" style="height:50px; width:200px;"></div>
    <div class="sb loading-shine sb-explicit" style="height:200px;"></div>
    <div class="sb loading-shine sb-explicit" style="width:100px; height:30px;"></div>
  </main>
</template>

